var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.8,
    height: 62.792,
    viewBox: "0 0 57.8 62.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bag-money-revenew-svgrepo-com",
    d: "M58.91,58.273,57.859,45.136c-1.051-11.823-7.356-19.7-17.077-26.273L43.409,3.1H30.273l-2.1,2.627h-5.78l1.576,8.407,11.56,1.576A1.919,1.919,0,0,1,37.1,17.55a1.757,1.757,0,0,1-1.839,1.576l-10.509-.263C15.035,25.432,8.729,33.314,7.941,45.136L6.89,58.273A3.94,3.94,0,0,0,4,61.951a4.041,4.041,0,0,0,3.941,3.941H57.859A4.041,4.041,0,0,0,61.8,61.951,3.94,3.94,0,0,0,58.91,58.273ZM23.442,41.2l5.78-.788,2.627-5.255a1.23,1.23,0,0,1,2.1,0l2.627,5.255,5.78.788a1.323,1.323,0,0,1,.788,2.1l-4.2,4.2,1.051,5.78a1.215,1.215,0,0,1-1.839,1.314L32.9,51.967l-5.255,2.627c-.788.525-1.839-.263-1.839-1.314l1.051-5.78-4.2-4.2A1.323,1.323,0,0,1,23.442,41.2Z",
    transform: "translate(-4 -3.1)",
    fill: "#5763f3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft4);
export default __webpack_public_path__ + "static/media/left_4.e1ec244a8bd7ef8264012131e75e40ba.svg";
export { ForwardRef as ReactComponent };